// extracted by mini-css-extract-plugin
module.exports = {"externalLink":"ExternalLink_externalLink__WrOjf","externalLinkText":"ExternalLink_externalLinkText__RMkmP","externalLinkIconWrapper":"ExternalLink_externalLinkIconWrapper__16s0F"};